<template>
  <span
    v-if="integerCount > 0"
    class="badge shrink-0"
    :class="
      !!customColorClass
        ? customColorClass
        : [
            flat ? `bg-${color}-${bg} text-white` : `bg-${color}-${bg} text-${color}-${text}`,
            { [`cursor-pointer hover:bg-${color}-${parseInt(bg) + 100}`]: clickable },
          ]
    "
    @click.stop="transmitClick"
  >
    <component
      :is="icon"
      v-if="icon"
      :class="[flat ? 'text-white' : `text-${color}-${text}`, 'mr-1 h-4 w-4']"
    />
    <slot>{{ count }}</slot>
  </span>
</template>

<script>
import { computed } from 'vue'
export default {
  name: 'Badge',
  props: {
    count: {
      type: [Number, String],
      default: 1,
    },
    color: {
      type: String,
      default: 'gray',
    },
    icon: {
      type: String,
      default: '',
    },
    bg: {
      type: String,
      default: '100',
    },
    text: {
      type: String,
      default: '800',
    },
    customColorClass: {
      type: String,
      default: '',
    },
    clickable: {
      type: Boolean,
      default: false,
    },
    flat: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['click'],
  setup(props) {
    const integerCount = computed(() => parseInt(props.count))
    return {
      integerCount,
    }
  },
  methods: {
    transmitClick() {
      // debugger
      // if (this.clickable) {
      this.$emit('click')
      // }
    },
  },
}
</script>
